import React from 'react'
import { useStateValue } from 'context/store'
import { Link } from 'react-router-dom'
import Utils from 'utils/utils'
import { makeStyles, ListItem, ListItemText } from '@material-ui/core'
import clsx from 'clsx'
import NewIcon from 'components/commons/NewIcon'

const useStyles = makeStyles(() => ({
   subItemText: {
      font: 'normal normal normal 14px/19px Roboto',
      letterSpacing: '0px',
      color: '#43496A',
      paddingLeft: '4px'
   },
   selectedItemWithLinkText: {
      font: 'normal normal bold 14px/19px Roboto'
   },
   selectedItemWithLink: {
      borderLeft: '2px solid #3264DC'
   },
   itemWithLink: {
      borderLeft: '1px solid rgba(0, 0, 0, 0.12)'
   }
}))

const MenuItemWithLink = ({
   submenu,
   parentMenuItem,
   setSecondaryDrawerOpen
}) => {
   const classes = useStyles()
   const url = '/dashboard'
   const itemTitle = Utils.getNoSpaceTitle(submenu.title)
   const [{ itemWithLinkSelection }, dispatch] = useStateValue()
   const menuTitle = submenu.title.replaceAll('_', ' ')

   const handleLinkClick = () => {
      dispatch({ type: 'ITEM_WITH_LINK_SELECTED', itemTitle })
      dispatch({
         type: 'SECONDARY_MENU_ITEM_SELECTED',
         itemTitle: parentMenuItem
      })
      setSecondaryDrawerOpen(false)
   }

   return (
      <ListItem
         className={
            itemWithLinkSelection?.currentState[itemTitle]
               ? classes.selectedItemWithLink
               : classes.itemWithLink
         }
         onClick={handleLinkClick}
         component={Link}
         to={`${url}${submenu.url}`}
         button
      >
         <ListItemText
            classes={{
               primary: clsx(classes.subItemText, {
                  [classes.selectedItemWithLinkText]:
                     itemWithLinkSelection?.currentState[itemTitle]
               })
            }}
            primary={menuTitle}
         />
         {submenu?.newOption ? <NewIcon /> : null}
      </ListItem>
   )
}

export default MenuItemWithLink
